import './index.scss'

import { initApp, setActiveNav } from 'app/js/app'

const $img = $('.certification .certification-img img')
const $onecloudBtn = $('#understandBtn')

setActiveNav()
$(() => {
  initApp()
  $onecloudBtn.click(() => {
    window.location.href = '/production/index.html'
  })
})

const certificationData = [
    {
      title: 'ISO9001',
      img: require('./img/iso.png')
    },
	{
		title: 'ISO20000',
		img: require('./img/iso2000.png'),
	},
	{
		title: 'ISO27001',
		img: require('./img/ISO27001.png')
	},
	{
		title: '可信云认证',
		img: require('./img/1ea06027.png')
	},
	/*{
		title: 'Advanced Consulting Partner',
		img: require('./img/aws.png'),
		size: 'contain',
		width: 140,
	},
	{
		title: 'Premier Level',
		img: require('./img/GCPA_Badge_Master.png'),
		size: 'contain',
		width: 150,
	},*/
	{
		title: '高新技术企业',
		img: require('./img/gxjsqy.png'),
		size: '80%',
	},
	{
		title: '双软认证',
		img: require('./img/shuangruan.png'),
		size: '90%',
	},
]


$('.certification-imgs-wrapper').each(function () {
  const _t = $(this)
  $.each(certificationData , function(index, data) {
    const {title, img, size, width} = data
      $(`<div class="swiper-slide"> <span style="background-image: url('${img}'); background-size: ${size ? size : 'cover'}; width:${width && `${width}px`} "></span> <h4>${title}</h4></div>`).appendTo(_t)
  })
})


new Swiper('.swiper-certification', {
	loop: true,
	slidesPerView: 6,
	navigation: {
		nextEl: '.swiper-certification-button-next',
		prevEl: '.swiper-certification-button-prev',
	},
});




new Swiper('.home-swiper', {
	loop: true,
	speed: 800,
	centeredSlides: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false
	},
	pagination: {
		el: '.home-swiper-pagination',
		clickable: true,
	},
});




// WEBPACK FOOTER //
// ./src/index/index.js